module.exports = __webpack_public_path__ + "static/media/Background-1Gamma.356b4ac2.jpg";